/**
 * Макет для страниц авторизации.
 * Тёмный фон на всё окно, центрирует содержимое.
 */
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';

const AuthLayout: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#0A0E17',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Outlet />
    </Box>
  );
};

export default AuthLayout;
